import ChatPanel from './chatPanel'

const chatRoutes = [
  {
    path: '/chatPanel',
    element: <ChatPanel />
  },
  {
    path: '/navigationPanel',
    element: <ChatPanel panelType="navigation" />
  }
]
export default chatRoutes;
